import defaultImage from '@/assets/images/default.png'

export function mapCategory(raw) {
  const imageUrl =
    typeof raw.image_url === 'string' && raw.image_url ? raw.image_url : defaultImage

  return {
    id: String(raw.id ?? ''),
    title: String(raw.title ?? ''),
    restoId: raw.resto_id != null ? String(raw.resto_id) : null,
    isActive: raw.is_active !== false,
    imageUrl,
  }
}
